
import { Vue, Component, Watch, Ref } from 'vue-property-decorator';
import lazyInject from '@/di';
import CarService from '@/services/car.service';
import LookCarPhone from '@/components/LookCarPhone.vue';
import EditThirdpartnarModal from './components/EditThirdpartnarModal.vue';
import { AuthEnum } from '@/services/permission.service';
import { DebounceTime } from '@/common/decorator';

@Component({
  components: {
    LookCarPhone,
    EditThirdpartnarModal,
  },
})
export default class ShopList extends Vue {
  @lazyInject(CarService)
  CarService!: CarService;

  @Ref('lookCarPhone')
  lookCarPhone!: LookCarPhone;

  @Ref('editThirdpartnarModal')
  editThirdpartnarModal!: EditThirdpartnarModal;

  AuthEnum = AuthEnum;

  listData = [];
  pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    onChange: this.pageChange,
  };

  marketList: any = [];

  kalist: any = [];

  form: any = {
    carShopId: '',
    carShopName: '',
    poi: '',
    carShopCode: '',
    onlineStatus: '',
    agentName: '',
    cityCode: '',
    merchantShopId: '',
    marketId: undefined,
    marketName: '',
    ka_id: undefined,
    labelId: undefined,
  };

  @Watch('$route')
  handleSearch() {
    const {
      carShopId,
      carShopName,
      poi,
      carShopCode,
      onlineStatus,
      agentName,
      advertiserName,
      cityCode,
      pageSize,
      page,
      merchantShopId,
      marketId,
      marketName,
      kaId,
      labelId,
    } = this.$route.query;
    const query: { [key: string]: any } = {
      page: page || 1,
      pageSize,
    };
    if (carShopId) {
      query.carShopId = carShopId;
      this.form.carShopId = carShopId;
    }
    if (carShopName) {
      query.carShopName = carShopName;
      this.form.carShopName = carShopName;
    }
    if (poi) {
      query.poi = poi;
      this.form.poi = poi;
    }
    if (carShopCode) {
      query.carShopCode = carShopCode;
      this.form.carShopCode = carShopCode;
    }
    if (onlineStatus) {
      query.onlineStatus = onlineStatus;
      this.form.onlineStatus = onlineStatus;
    }
    if (agentName) {
      query.agentName = agentName;
      this.form.agentName = agentName;
    }
    if (advertiserName) {
      query.advertiserName = advertiserName;
      this.form.advertiserName = advertiserName;
    }
    if (cityCode) {
      query.cityCode = cityCode;
      this.form.cityCode = cityCode;
    }
    if (merchantShopId) {
      query.merchantShopId = merchantShopId;
      this.form.merchantShopId = merchantShopId;
    }
    if (kaId) {
      query.kaId = kaId;
      this.form.ka_id = +kaId;
    }
    if (labelId) {
      query.labelId = labelId;
      this.form.labelId = +labelId;
    }
    if (marketId) {
      query.marketId = marketId;
      this.form.marketId = +marketId;
      if (this.marketList.length === 0) {
        this.onHandleSearch(marketName);
      }
    }
    this.getList(query);
  }

  labelList: any = [
    {
      value: 2,
      table: '二手车',
    },
    {
      value: 3,
      table: '车务代理',
    },
    {
      value: 4,
      table: '汽车配件',
    },
  ];

  toDetail(item: any) {
    // console.log(item);
    const routeUrl = this.$router.resolve({
      name: 'car.detail',
      params: {
        id: `${item.car_shop_code}`,
      },
    });
    window.open(routeUrl.href, '_blank');
  }

  pageChange(page: number, pageSize: number) {
    // console.log(page, pageSize);
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.changeQuery();
  }

  search() {
    this.pagination.current = 1;
    this.changeQuery();
  }

  async getKaList() {
    const response = await this.CarService.getCarKaAll();
    if (response) {
      this.kalist = response;
    }
  }

  changeLabelId(id: number) {
    switch (id) {
      case 2:
        return '二手车';
      case 3:
        return '车务代理';
      case 4:
        return '汽车配件';
      default:
        return '';
    }
  }

  @DebounceTime()
  async onHandleSearch(val: any) {
    if (val) {
      const params = {
        marketName: val,
      };
      const res = await this.CarService.getCarShopMarketList(params);
      this.marketList = res.list;
    } else {
      this.marketList = [];
    }
  }

  handleChange(val: any) {
    // console.log(val, 's');
    this.form.marketId = val;
    this.form.marketName = this.marketList.find(
      (item: any) => item.market_id === val,
    ).name;
    // console.log(this.form);
  }

  reset() {
    this.pagination.current = 1;
    const { pageSize } = this.pagination;
    const query: { [key: string]: any } = {
      timestamp: `${Math.round(Date.now() / 1000)}`,
      page: 1,
      pageSize,
    };
    this.form = {
      carShopId: '',
      carShopName: '',
      poi: '',
      carShopCode: '',
      onlineStatus: '',
      agentName: '',
      advertiserName: '',
      cityCode: '',
      merchantShopId: '',
      marketId: undefined,
      marketName: '',
      ka_id: undefined,
      labelId: undefined,
    };
    this.$router.push({
      query,
    });
  }

  changeQuery() {
    const {
      carShopId,
      carShopName,
      poi,
      carShopCode,
      onlineStatus,
      agentName,
      advertiserName,
      cityCode,
      merchantShopId,
      marketId,
      marketName,
      ka_id,
      labelId,
    } = this.form;
    const { current, pageSize } = this.pagination;
    const query: { [key: string]: any } = {
      timestamp: `${Math.round(Date.now() / 1000)}`,
      page: current,
      pageSize,
    };
    if (carShopId) {
      query.carShopId = carShopId;
    }
    if (carShopName) {
      query.carShopName = carShopName;
    }
    if (poi) {
      query.poi = poi;
    }
    if (carShopCode) {
      query.carShopCode = carShopCode;
    }
    if (onlineStatus) {
      query.onlineStatus = onlineStatus;
    }
    if (agentName) {
      query.agentName = agentName;
    }
    if (advertiserName) {
      query.advertiserName = advertiserName;
    }
    if (cityCode) {
      query.cityCode = cityCode;
    }
    if (merchantShopId) {
      query.merchantShopId = merchantShopId;
    }
    if (marketId) {
      query.marketId = marketId;
      query.marketName = marketName;
    }
    if (ka_id) {
      query.kaId = ka_id;
    }
    if (labelId) {
      query.labelId = labelId;
    }
    this.$router.push({
      query,
    });
  }

  copyToClipboard(item: any) {
    this.$copyText(String(item)).then(
      () => {
        this.$message.success('复制成功');
      },
      (err) => {
        this.$message.error(`复制失败:${err}`);
      },
    );
  }

  LookShopDetail(val: any) {
    this.lookCarPhone.init('二手车店铺列表-电话', val.encryptedTels, val.poi);
  }

  async getList(query: any) {
    const res = await this.CarService.getCarShopList(query, this.$el);
    if (res) {
      this.listData = res.list;
      this.pagination.total = res.total;
    }
  }

  async mounted() {
    await this.handleSearch();
    await this.getKaList();
  }

  showEditThirdpartnarModal(item: any, type: string) {
    // console.log(item);
    this.editThirdpartnarModal.open(item, type);
  }
}
